import { frontendURL } from '../../../helper/URLHelper';
import WaitlistView from './pages/WaitlistView.vue';

const meta = { permissions: ['administrator', 'agent'] };
export const routes = [
  {
    path: frontendURL('accounts/:accountId/waitlist'),
    name: 'waitlist_index',
    component: WaitlistView,
    meta,
  },
];
